export const blogArticles = [
  {
    id: 1,
    title: "Navigating Open Access Publishing: Mega Journals Or Open Access Journals",
    date: "May 14, 2024",
    image: "https://vikramshilaedu.in/GyanKosh/wp-content/uploads/2024/05/Blog-Banner.jpeg",
    excerpt: "The concept of Mega Journals is not new. There are many Mega Journals platforms available globally. However, Mega Journals is a relatively new concept in India. In the ever-evolving landscape ...",
    link: "https://vikramshilaedu.in/GyanKosh/navigating-open-access-publishing-mega-journals-vs-open-access-journals/",
    slug: "navigating-open-access-publishing-mega-journals-vs-open-access-journals"
  },
  {
    id: 2,
    title: "Rise of Chinese Research Publishing",
    date: "February 8, 2023",
    image: "https://vikramshilaedu.in/GyanKosh/wp-content/uploads/2023/02/image-127.png",
    excerpt: "Rise of Chinese Research Publishing: What are the lessons for India? Today, China is at number one in research publishing with almost 800,000 articles being published every year. (Source: Clarivate 2021) ...",
    link: "https://vikramshilaedu.in/GyanKosh/understanding-the-rise-of-chinese-research-publishing-lessons-for-india/",
    slug: "understanding-the-rise-of-chinese-research-publishing-lessons-for-india"
  },
  {
    id: 3,
    title: "The end of Journal Publishing in India?",
    date: "February 8, 2023",
    image: "https://vikramshilaedu.in/GyanKosh/wp-content/uploads/2023/02/Group-3518.png",
    excerpt: "One Nation, One Subscription Don’t get me wrong, I welcome the move by the government to negotiate a deal for all researchers and take a bold step in leveling the ...",
    link: "https://vikramshilaedu.in/GyanKosh/one-nation-one-subscription-the-end-of-journal-publishing-in-india/",
    slug: "one-nation-one-subscription-the-end-of-journal-publishing-in-india"
  },
  {
    id: 4,
    title: "Be Aware of Your Rights as an Author",
    date: "January 24, 2023",
    image: "https://vikramshilaedu.in/GyanKosh/wp-content/uploads/2023/01/url-e1674564684950.png",
    excerpt: "The issue of Copyright is a complex one and almost authors aren’t aware of the rights they create, assign, and need reverted. Most authors are aware that when they write ...",
    link: "https://vikramshilaedu.in/GyanKosh/are-you-aware-of-your-rights-as-an-author/",
    slug: "are-you-aware-of-your-rights-as-an-author"
  },
  {
    id: 5,
    title: "The World of Peer Review",
    date: "January 24, 2023",
    image: "https://vikramshilaedu.in/GyanKosh/wp-content/uploads/2023/01/Article-2_Claim-your-place-in-the-world-of-peer-review-e1674564547405.jpg",
    excerpt: "Okay, we hear you. You’re interested in building your profile and becoming a formidable Peer Reviewer. Good start! Peer review is at the heart of every research. It allows your ...",
    link: "https://vikramshilaedu.in/GyanKosh/claim-your-place-in-the-world-of-peer-review/",
    slug: "claim-your-place-in-the-world-of-peer-review"
  },
  {
    id: 6,
    title: "Peer Review with Vikramshila",
    date: "January 24, 2023",
    image: "https://vikramshilaedu.in/GyanKosh/wp-content/uploads/2023/01/Article-3_Join-Vikramshila-as-a-Peer-Reviewer-1-1.png",
    excerpt: "First, let us address the elephant in the room. Is it your first-time as a peer reviewer? Have you been thinking about listing yourself as one but have no idea ...",
    link: "https://vikramshilaedu.in/GyanKosh/joining-vikramshila-as-a-peer-reviewer/",
    slug: "joining-vikramshila-as-a-peer-reviewer"
  },
  {
    id: 7,
    title: "The Enchanting World of Peer Review",
    date: "January 24, 2023",
    image: "https://vikramshilaedu.in/GyanKosh/wp-content/uploads/2023/01/Article-4_The-Enchanting-World-of-Peer-Review-e1674633697705.jpg",
    excerpt: "Peer Review is the bridge that connects the author to its destination, their published article. In its true form, it is a symbol of real collaboration. Besides ensuring the integrity ...",
    link: "https://vikramshilaedu.in/GyanKosh/the-enchanting-world-of-peer-review/",
    slug: "the-enchanting-world-of-peer-review"
  },
  {
    id: 8,
    title: "Understanding How Editors Think",
    date: "January 24, 2023",
    image: "https://vikramshilaedu.in/GyanKosh/wp-content/uploads/2023/01/Article-5_How-Editors-Think.jpg",
    excerpt: "In the research circles, an early career researcher often imagines a Publishing Editor as a stiff, stern looking figure of authority, sitting behind an enormously large desk, spending their day ...",
    link: "https://vikramshilaedu.in/GyanKosh/understanding-how-editors-think/",
    slug: "understanding-how-editors-think"
  },
  {
    id: 9,
    title: "The Press and Registration of Books Act",
    date: "January 24, 2023",
    image: "https://vikramshilaedu.in/GyanKosh/wp-content/uploads/2023/01/Article-6_The-Press-and-Registration-of-Books-Act.jpg",
    excerpt: "Updated: Mar 25, 2020 1867 is a result of many previous draconian laws being repealed and or being merged into one. It has been in existence for 151 years! In many ...",
    link: "https://vikramshilaedu.in/GyanKosh/the-press-and-registration-of-books-act/",
    slug: "the-press-and-registration-of-books-act"
  }
];
